import React, { useContext } from 'react';
import TeacketContext from 'src/context/TeacketContext';
import useAsyncProcesses from 'src/hooks/useAsyncProcesses';
import useUserInfo from 'src/hooks/useUserInfo';
//import useUserInfo from 'src/hooks/useUserInfo';
// import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import PropertyItem from 'src/components/layout/PropertyItem';
import TicketActiveViewers from './TicketActiveViewers';
import { notEmptyArray } from 'src/misc/Misc';
import { Dropdown, Space, notification } from 'antd';
import { FaSortDown } from 'react-icons/fa';
import { patchTicket } from 'src/api/teacket';

dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);

const TicketProperties = () => {
  const { executeAsyncProcess } = useAsyncProcesses();
  const { currentTicket, activeViewers, servicesForTenant, updateCurrentTicket, currentTicketReadOnly } = useContext(TeacketContext);
  const { id: userId } = useUserInfo();

  const serviceName = servicesForTenant?.find((service) => service.id === currentTicket?.service_id)?.name;
  const statusOptions = servicesForTenant?.find((service) => service.id === currentTicket?.service_id)?.props?.statusList?.map(({ status }) => ({ key: status, label: status }));
  const priorityOptions = servicesForTenant?.find((service) => service.id === currentTicket?.service_id)?.props?.priorityList?.map(({ priority }) => ({ key: priority, label: priority }));

  const handleOnStatusChange = async (e) => {
    console.log('handleOnStatusChange()', e);
    if (currentTicket?.status === e.key) return;
    await executeAsyncProcess(async () => {
      try {
        const status = e.key;
        const ticket = await patchTicket(currentTicket.id, { status });
        updateCurrentTicket(ticket);
        notification.success({ message: 'Status successfully updated' });
      } catch (error) {
        console.error(error);
      }
    });
  };

  const handleOnPriorityChange = (e) => {
    console.log('handleOnPriorityChange()', e);
    if (currentTicket?.priority === e.key) return;
    executeAsyncProcess(async () => {
      try {
        const priority = e.key;
        const ticket = await patchTicket(currentTicket.id, { priority });
        updateCurrentTicket(ticket);
        notification.success({ message: 'Priority successfully updated' });
      } catch (error) {
        console.error(error);
      }
    });
  };

  return (
    <>
      <div className='flex flex-col gap-2 mt-4'>
        <PropertyItem label='Service' value={serviceName} secondValue={currentTicket.service_id} />
        <PropertyItem label='Ticket ID' value={currentTicket?.id} />
        {true === notEmptyArray(activeViewers.filter((user) => user.user_id !== userId)) && <PropertyItem label='Others are also viewing this ticket' value={<TicketActiveViewers />} loading={!currentTicket} />}
        <PropertyItem label='Category / SubCategory' value={currentTicket.category} secondValue={currentTicket.sub_category} />
        <PropertyItem
          label='Status'
          value={
            <Dropdown menu={{ items: statusOptions, onClick: handleOnStatusChange }} trigger={['click']} placement='bottomRight' disabled={currentTicketReadOnly}>
              <Space className='cursor-pointer'>
                <span>{currentTicket?.status}</span>
                <FaSortDown />
              </Space>
            </Dropdown>
          }
        />
        <PropertyItem
          label='Priority'
          value={
            <Dropdown menu={{ items: priorityOptions, onClick: handleOnPriorityChange }} trigger={['click']} placement='bottomRight' disabled={currentTicketReadOnly}>
              <Space className='cursor-pointer'>
                <span>{currentTicket?.priority}</span>
                <FaSortDown />
              </Space>
            </Dropdown>
          }
        />
        <PropertyItem label='Created' value={currentTicket?.created_at ? dayjs(currentTicket?.created_at).fromNow() : null} secondValue={currentTicket?.created_at ? dayjs(currentTicket?.created_at).format('LLL') : null} />
        <PropertyItem label='Updated' value={currentTicket?.updated_at ? dayjs(currentTicket?.updated_at).fromNow() : null} secondValue={currentTicket?.updated_at ? dayjs(currentTicket?.updated_at).format('LLL') : null} />
      </div>
    </>
  );
};

TicketProperties.propTypes = {};

export default TicketProperties;
